// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__3mib4","containerItemsCenter":"Skeleton_containerItemsCenter__6wkty"};